import { ChallengeConfigData } from '../test-configurator-provider.interfaces';

export const eqChallengeConfigData = (configDataA: ChallengeConfigData, configDataB: ChallengeConfigData) => {
  if (configDataA.title !== configDataB.title) {
    return false;
  }
  if (configDataA.description !== configDataB.description) {
    return false;
  }
  if (configDataA.startDate.toDateString() !== configDataB.startDate.toDateString()) {
    return false;
  }
  if (configDataA.finishDate.toDateString() !== configDataB.finishDate.toDateString()) {
    return false;
  }
  if (configDataA.isPrivate !== configDataB.isPrivate) {
    return false;
  }
  return true;
};
